import React, { useRef } from "react";
import BaseSection from "../../BaseSection";
import Responsable from "../../../Responsable";
import ScrollOverlayPartners from "../scrollOverays/ScrollOverlayPartners";
import PartnersCarousel from "../../../PartnersCarousel";
import styled from "styled-components";
import { media } from "../../../../constants/styles";

interface HomeSection02_3Props {}

const HomeSection02_3: React.FC<HomeSection02_3Props> = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <BaseSection ref={containerRef}>
      <Responsable
        backgroundColor="black"
        pc={
          <Container>
            <ScrollOverlayPartners screenType="PC" />
            <PartnersCarousel screenType="PC" />
          </Container>
        }
        tablet={
          <Container>
            <ScrollOverlayPartners screenType="TABLET" />
            <PartnersCarousel screenType="TABLET" />
          </Container>
        }
        mobile={
          <Container>
            <ScrollOverlayPartners screenType="MOBILE" />
            <PartnersCarousel screenType="MOBILE" />
          </Container>
        }
      />
    </BaseSection>
  );
};

export default HomeSection02_3;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 100px;
  padding: 160px 0;

  ${media.TABLET} {
    padding: 140px 0;
  }
  ${media.MOBILE} {
    gap: 60px;
    padding: 80px 0;
  }
`;
